import PrivacyPolicy from 'screens/PrivacyPolicy';

export default PrivacyPolicy;
